// PrivacyPolicy.js
import React from 'react';
import './PrivacyPolicy.css'; // Optional: for styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p>
        At WaterSprint Ltd., we respect your privacy and are committed to protecting your personal information. We collect only the data necessary to provide and improve our services, including your contact details and usage information, which may be gathered through forms, cookies, or analytics tools. Your information is never sold or shared with third parties except as required to deliver our solutions or comply with legal obligations. We store data securely and in accordance with UK GDPR, ensuring transparency and control over your personal information at all times.
      </p>
    </div>
  );
};

export default PrivacyPolicy;